export const URL_PROTOCOL = /(^\w+:|^)\/\/|\/$/g;

export const PAYMENT_PAGE_URL_LIST = [
  'success',
  'fail',
  '404',
  'denied',
  'entercard',
  'secure',
  'paid',
  'failed',
  'rejected',
  'wait',
  'blocked',
  'payed',
  'pending',
  'origin',
  'expired',
  'receipt',
  'deal',
  'content/paid',
  'subscription/manage',
  'confirmation/sms',
];
